exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-top[data-v-8e5c6624] {\n  position: absolute;\n  top: 58px;\n  z-index: 99;\n  border-radius: 0;\n  margin-left: 1px;\n  width: calc(100% - 2px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8e5c6624","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/alert-container/AlertContainer.vue
// module id = 684
// module chunks = 1